import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './images/android.png';
import _imports_1 from './images/weibo.png';
import _imports_2 from './images/bzhan.png';
import _imports_3 from './images/police.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-b4e4b4a4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container-fluild long-container"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("svg", {
    t: "1659602860431",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "3763",
    width: "20",
    height: "20"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M910.222222 796.444444c-17.066667 0-34.133333-5.688889-45.511111-17.066666L551.822222 409.6c-11.377778-5.688889-17.066667-11.377778-34.133333-11.377778-5.688889 0-22.755556 5.688889-28.444445 11.377778l-329.955555 364.088889c-22.755556 22.755556-56.888889 22.755556-79.644445 5.688889-22.755556-22.755556-22.755556-56.888889-5.688888-79.644445l329.955555-364.088889c28.444444-34.133333 73.955556-51.2 119.466667-51.2s85.333333 22.755556 119.466666 56.888889l312.888889 364.088889c22.755556 22.755556 17.066667 56.888889-5.688889 79.644445-11.377778 5.688889-28.444444 11.377778-39.822222 11.377777z",
    "p-id": "3764",
    fill: "#ffffff"
  })], -1);
});

var _hoisted_3 = [_hoisted_2];
var _hoisted_4 = {
  class: "container"
};
var _hoisted_5 = {
  class: "row long-row"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "col-md-5 contact"
  }, [/*#__PURE__*/_createElementVNode("h3", null, [/*#__PURE__*/_createElementVNode("svg", {
    t: "1649321039266",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "9728",
    width: "22",
    height: "22"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M511.449009 213.858462a179.278769 179.278769 0 1 1 0 358.557538 179.278769 179.278769 0 0 1 0-358.557538z m393.294769 179.357538A393.294769 393.294769 0 1 0 182.036086 608.098462l294.203077 392.270769a39.384615 39.384615 0 0 0 70.498462 0l294.754461-392.270769c39.699692-61.912615 63.251692-135.483077 63.251692-214.882462z",
    "p-id": "9729",
    fill: "#ffffff"
  })]), /*#__PURE__*/_createTextVNode(" 联系 ")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode(" 邮箱：bloodline@xuehome.com.cn"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 电话：13260103350 ")])], -1);
});

var _hoisted_7 = {
  class: "col-md-4 navigation"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h3", null, [/*#__PURE__*/_createElementVNode("svg", {
    t: "1649322292493",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "17869",
    width: "22",
    height: "22"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M1000.533333 0c-4.266667 0-8.533333 0-10.666666 2.133333L12.8 531.2c-21.333333 12.8-12.8 44.8 10.666667 44.8h401.066666c12.8 0 23.466667 10.666667 23.466667 23.466667v401.066666c0 14.933333 12.8 23.466667 23.466667 23.466667 8.533333 0 14.933333-4.266667 21.333333-12.8L1021.866667 34.133333c8.533333-17.066667-4.266667-34.133333-21.333334-34.133333z",
    fill: "#ffffff",
    "p-id": "17870"
  })]), /*#__PURE__*/_createTextVNode(" 导航 ")], -1);
});

var _hoisted_9 = /*#__PURE__*/_createTextVNode("首 页 (Home)");

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, null, -1);
});

var _hoisted_11 = /*#__PURE__*/_createTextVNode("献血知识 (Knowledge)");

var _hoisted_12 = /*#__PURE__*/_createTextVNode("新闻动态 (News)");

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, null, -1);
});

var _hoisted_14 = /*#__PURE__*/_createTextVNode("联系我们 (Contact)");

var _hoisted_15 = {
  class: "col-md-3"
};

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h3", null, [/*#__PURE__*/_createElementVNode("svg", {
    t: "1649322884249",
    class: "icon",
    viewBox: "0 0 1025 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "22869",
    width: "22",
    height: "22"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M1024.549 360.609c0-170.492-133.815-309.265-298.055-309.265-81.129 0-157.91 34.998-213.344 94.701-55.509-59.702-132.367-94.701-213.344-94.701C135.49 51.344 1.751 190.041 1.751 360.609c0 5.719 0.534 10.827 0.991 15.021-0.076 1.373-0.152 2.745-0.152 4.194 0 30.193 7.319 63.361 21.73 98.59 0.458 1.295 0.915 2.516 1.449 3.657 90.812 217.844 440.412 468.474 455.279 479.985 9.227 7.092 20.205 10.6 31.263 10.6 11.209 0 22.266-3.659 31.566-10.903 12.733-9.911 310.941-224.551 429.279-427.603 4.498-6.861 7.854-13.494 10.828-19.215 0.914-1.829 1.753-3.658 2.744-5.413l0.382-0.839c0.382-0.686 0.839-1.449 1.296-2.059 7.091-13.802 12.732-26.611 17.232-39.116 12.274-32.177 18.3-60.847 18.3-87.61 0-2.058-0.077-3.888-0.229-5.414C1024.093 370.979 1024.549 366.251 1024.549 360.609z",
    "p-id": "22870",
    fill: "#ffffff"
  })]), /*#__PURE__*/_createTextVNode(" 应用下载 ")], -1);
});

var _hoisted_17 = {
  class: "social"
};

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("path", {
    d: "M290.171776 733.916229c0 20.340257 16.636912 36.982286 36.97103 36.982286l36.97103 0 0 129.436978c0 30.695093 24.771173 55.473429 55.457056 55.473429s55.457056-24.778336 55.457056-55.473429L475.027947 770.897492l73.943083 0 0 129.436978c0 30.695093 24.771173 55.473429 55.457056 55.473429s55.457056-24.778336 55.457056-55.473429L659.885142 770.897492l36.97103 0c20.334117 0 36.97103-16.642029 36.97103-36.982286L733.827201 364.094392 290.171776 364.094392 290.171776 733.916229zM197.74369 364.094392c-30.685883 0-55.457056 24.778336-55.457056 55.473429l0 258.874979c0 30.695093 24.771173 55.473429 55.457056 55.473429s55.457056-24.778336 55.457056-55.473429L253.200746 419.567821C253.200746 388.872728 228.429573 364.094392 197.74369 364.094392zM826.25631 364.094392c-30.685883 0-55.457056 24.778336-55.457056 55.473429l0 258.874979c0 30.695093 24.771173 55.473429 55.457056 55.473429 30.685883 0 55.457056-24.778336 55.457056-55.473429L881.713366 419.567821C881.713366 388.872728 856.942193 364.094392 826.25631 364.094392zM642.508379 148.118456 690.756243 99.857289c7.209192-7.211239 7.209192-18.860557 0-26.072819-7.209192-7.211239-18.85544-7.211239-26.064632 0l-54.717206 54.54836c-29.576619-14.607696-62.666248-23.113417-97.974405-23.113417-35.492352 0-68.7672 8.505721-98.529037 23.298636l-54.902424-54.918797c-7.209192-7.211239-18.85544-7.211239-26.064632 0-7.209192 7.211239-7.209192 18.860557 0 26.072819l48.432059 48.446385c-54.902424 40.495296-90.76419 105.58371-90.76419 178.99365l443.656449 0C733.828224 253.517971 697.78124 188.429557 642.508379 148.118456zM438.056917 253.147534l-36.97103 0 0-36.982286 36.97103 0L438.056917 253.147534zM622.914112 253.147534l-36.97103 0 0-36.982286 36.97103 0L622.914112 253.147534z",
    fill: "#ffffff",
    "p-id": "2764"
  }, null, -1);
});

var _hoisted_19 = [_hoisted_18];
var _hoisted_20 = {
  class: "douyin"
};

var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "抖音二维码"
  }, null, -1);
});

var _hoisted_22 = [_hoisted_21];

var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("path", {
    d: "M836.608 675.84q41.984 59.392 96.256 76.8-23.552 72.704-74.752 151.552-78.848 118.784-155.648 118.784-28.672 0-84.992-19.456-52.224-19.456-91.136-19.456t-86.016 20.48q-49.152 19.456-80.896 19.456-92.16 0-181.248-156.672-89.088-154.624-89.088-304.128 0-138.24 67.584-226.304 69.632-88.064 172.032-88.064 22.528 0 50.176 5.632t57.344 20.992q31.744 17.408 52.224 24.064t31.744 6.656q13.312 0 40.96-6.144t55.296-22.528q29.696-16.384 51.2-24.576t44.032-8.192q71.68 0 129.024 38.912 30.72 20.48 62.464 60.416-47.104 40.96-68.608 71.68-39.936 57.344-39.936 124.928 0 74.752 41.984 135.168z m-205.824-478.208q-35.84 33.792-65.536 44.032-10.24 3.072-26.112 5.632t-36.352 4.608q1.024-90.112 47.104-155.648T701.44 6.144q2.048 10.24 3.072 14.336v11.264q0 36.864-17.408 82.944-18.432 45.056-56.32 82.944z",
    fill: "#ffffff",
    "p-id": "1726"
  }, null, -1);
});

var _hoisted_24 = [_hoisted_23];
var _hoisted_25 = {
  class: "weibo"
};

var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "微博二维码"
  }, null, -1);
});

var _hoisted_27 = [_hoisted_26];

var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("path", {
    d: "M1147.26896 912.681417l34.90165 111.318583-127.165111-66.823891a604.787313 604.787313 0 0 1-139.082747 22.263717c-220.607239 0-394.296969-144.615936-394.296969-322.758409s173.526026-322.889372 394.296969-322.889372C1124.219465 333.661082 1309.630388 478.669907 1309.630388 656.550454c0 100.284947-69.344929 189.143369-162.361428 256.130963zM788.070086 511.869037a49.11114 49.11114 0 0 0-46.360916 44.494692 48.783732 48.783732 0 0 0 46.360916 44.494693 52.090549 52.090549 0 0 0 57.983885-44.494693 52.385216 52.385216 0 0 0-57.983885-44.494692z m254.985036 0a48.881954 48.881954 0 0 0-46.09899 44.494692 48.620028 48.620028 0 0 0 46.09899 44.494693 52.385216 52.385216 0 0 0 57.983886-44.494693 52.58166 52.58166 0 0 0-57.951145-44.494692z m-550.568615 150.018161a318.567592 318.567592 0 0 0 14.307712 93.212943c-14.307712 1.080445-28.746387 1.768001-43.283284 1.768001a827.293516 827.293516 0 0 1-162.394168-22.296458l-162.001279 77.955749 46.328175-133.811485C69.410411 600.858422 0 500.507993 0 378.38496 0 166.683208 208.689602 0 463.510935 0c227.908428 0 427.594322 133.18941 467.701752 312.379588a427.463358 427.463358 0 0 0-44.625655-2.619261c-220.24709 0-394.100524 157.74498-394.100525 352.126871zM312.90344 189.143369a64.270111 64.270111 0 0 0-69.803299 55.659291 64.532037 64.532037 0 0 0 69.803299 55.659292 53.694846 53.694846 0 0 0 57.852923-55.659292 53.465661 53.465661 0 0 0-57.852923-55.659291z m324.428188 0a64.040926 64.040926 0 0 0-69.574114 55.659291 64.302852 64.302852 0 0 0 69.574114 55.659292 53.694846 53.694846 0 0 0 57.951145-55.659292 53.465661 53.465661 0 0 0-57.951145-55.659291z",
    fill: "#ffffff",
    "p-id": "3987"
  }, null, -1);
});

var _hoisted_29 = [_hoisted_28];
var _hoisted_30 = {
  class: "bzhan"
};

var _hoisted_31 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "B站二维码"
  }, null, -1);
});

var _hoisted_32 = [_hoisted_31];

var _hoisted_33 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "container-fluild long-container-bootom text-center"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "备案号"
  }), /*#__PURE__*/_createElementVNode("span", null, "© 血缘之家 "), /*#__PURE__*/_createElementVNode("a", {
    href: "https://beian.miit.gov.cn/#/Integrated/recordQuery",
    style: {
      "color": "#ebebeb"
    },
    target: "_blank"
  }, " 京ICP备2025132718号-2 ")], -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "toTop",
    onClick: _cache[0] || (_cache[0] = function () {
      return $setup.toTop && $setup.toTop.apply($setup, arguments);
    })
  }, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("p", null, [_createVNode(_component_router_link, {
    to: "/home"
  }, {
    default: _withCtx(function () {
      return [_hoisted_9];
    }),
    _: 1
  })]), _hoisted_10, _createElementVNode("p", null, [_createVNode(_component_router_link, {
    to: "/knowledge"
  }, {
    default: _withCtx(function () {
      return [_hoisted_11];
    }),
    _: 1
  })]), _createElementVNode("p", null, [_createVNode(_component_router_link, {
    to: "/news"
  }, {
    default: _withCtx(function () {
      return [_hoisted_12];
    }),
    _: 1
  })]), _hoisted_13, _createElementVNode("p", null, [_createVNode(_component_router_link, {
    to: "/contact"
  }, {
    default: _withCtx(function () {
      return [_hoisted_14];
    }),
    _: 1
  })])]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("a", null, [(_openBlock(), _createElementBlock("svg", {
    onMouseenter: _cache[1] || (_cache[1] = function ($event) {
      return $setup.showQR('android');
    }),
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $setup.handleDownload('0');
    }),
    onMouseleave: _cache[3] || (_cache[3] = function () {
      return $setup.hiddenQR && $setup.hiddenQR.apply($setup, arguments);
    }),
    t: "1753668636208",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "2763",
    width: "30",
    height: "30"
  }, _hoisted_19, 32)), _createVNode(_Transition, {
    name: "douyin",
    appear: "",
    class: "animate__animated",
    "enter-active-class": "animate__fadeIn",
    "leave-active-class": "animate__zoomOut"
  }, {
    default: _withCtx(function () {
      return [_withDirectives(_createElementVNode("div", _hoisted_20, _hoisted_22, 512), [[_vShow, $setup.isShowDouYin]])];
    }),
    _: 1
  })]), _createElementVNode("a", null, [(_openBlock(), _createElementBlock("svg", {
    onMouseenter: _cache[4] || (_cache[4] = function ($event) {
      return $setup.showQR('apple');
    }),
    onMouseleave: _cache[5] || (_cache[5] = function () {
      return $setup.hiddenQR && $setup.hiddenQR.apply($setup, arguments);
    }),
    t: "1753668377724",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "1725",
    width: "30",
    height: "30"
  }, _hoisted_24, 32)), _createVNode(_Transition, {
    name: "weibo",
    appear: "",
    class: "animate__animated",
    "enter-active-class": "animate__fadeIn",
    "leave-active-class": "animate__zoomOut"
  }, {
    default: _withCtx(function () {
      return [_withDirectives(_createElementVNode("div", _hoisted_25, _hoisted_27, 512), [[_vShow, $setup.isShowWeibo]])];
    }),
    _: 1
  })]), _createElementVNode("a", null, [(_openBlock(), _createElementBlock("svg", {
    onMouseenter: _cache[6] || (_cache[6] = function ($event) {
      return $setup.showQR('wechat');
    }),
    onMouseleave: _cache[7] || (_cache[7] = function () {
      return $setup.hiddenQR && $setup.hiddenQR.apply($setup, arguments);
    }),
    t: "1753668851706",
    class: "icon",
    viewBox: "0 0 1309 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "3986",
    width: "30",
    height: "30"
  }, _hoisted_29, 32)), _createVNode(_Transition, {
    name: "bzhan",
    appear: "",
    class: "animate__animated",
    "enter-active-class": "animate__fadeIn",
    "leave-active-class": "animate__zoomOut"
  }, {
    default: _withCtx(function () {
      return [_withDirectives(_createElementVNode("div", _hoisted_30, _hoisted_32, 512), [[_vShow, $setup.isShowBzhan]])];
    }),
    _: 1
  })])])])])]), _hoisted_33]);
}